/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_2_HInputs */

const en_terms_2_h = /** @type {(inputs: Terms_2_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account`)
};

const id_terms_2_h = /** @type {(inputs: Terms_2_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akunmu`)
};

/**
* | output |
* | --- |
* | "Your account" |
*
* @param {Terms_2_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_2_h = /** @type {((inputs?: Terms_2_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_2_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_2_h(inputs)
	return en_terms_2_h(inputs)
});